import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function AppBase({
    children,
    className,
    ...rest
}) {
    return (
        <div
            data-component="AppBase"
            className={cx('shared-app-base', 'rec-page', className)}
            {...rest}>
            {children}
        </div>
    );
}

AppBase.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
}
